import { useEffect } from 'react';
import isEmpty from 'lodash/isEmpty';

import useSavedFiltersStore, { useGetSavedFilters } from 'Stores/SavedFiltersStore/SavedFiltersStore';
import useFeatureToggle, { FEATURES } from 'Utilities/hooks/useFeatureToggle';

const useSetSavedFilters = (filtersResponse) => {
	const isMirageEnabled = useFeatureToggle(FEATURES.mirageServer);
	const getSavedFilters = useGetSavedFilters();

	useEffect(() => {
		if (isMirageEnabled) {
			setTimeout(() => getSavedFilters());
			return;
		}

		if (!isEmpty(filtersResponse)) {
			useSavedFiltersStore.setState(filtersResponse);
		}
	}, [filtersResponse, getSavedFilters, isMirageEnabled]);
};

export default useSetSavedFilters;
